export enum EMOTICON_TYPES {
	Failure,
	Success,
	Unknown
}
